<script setup lang="ts">
import { PropertySchema } from "~/classes/entity"

const props = defineProps({
  files: null
})

const imageMetadata = computed(() => mapped(props.files, f => f.imageMetadata()))
const imageMetadataKeys = computed(() => Array.from(new Set(Object.values(imageMetadata.value).flatMap(d => d ? Object.keys(d) : []))).sort())

function stringProperty(
  field: string,
): Record<string, EntityPropertyValue | undefined> {
  return mapped(imageMetadata.value, (metadata) => {
    if (metadata && field in metadata)
      return { type: PropertySchema.AnyStringValue, anyString: metadata[field] as any }
  })
}
function isSingleMultilineField(
  field: string,
) {
  if (len(imageMetadata.value) > 1)
    return false
  const value = first(imageMetadata.value)?.[field] ?? ""
  if (typeof value === "string")
    return len(value) > 24
  else return len(JSON.stringify(value)) > 24
}

// SVGs don't have height and width metadata (they could though?)
const allSvg = computed(() => all(Object.values(props.files), f => f.isSvg()))

</script>

<template>
  <panel-details-property-section class="section">
    <template #header>
      Image Details
    </template>

    <panel-details-property-dimensions :files v-if="!allSvg" />
    <panel-details-property-field
      v-for="key in imageMetadataKeys"
      :key
      :label="key"
      :values="stringProperty(key)"
      :multiline="isSingleMultilineField(key)"
    />
  </panel-details-property-section>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'
</style>
